/**
 * Países en español (ISO 3166-1 alpha-2). Fuente única para selectores de perfil.
 */
const ISO_ALPHA2 = [
  "AF", "AL", "DE", "AD", "AO", "AI", "AQ", "AG", "SA", "DZ", "AR", "AM", "AW", "AU", "AT", "AZ",
  "BS", "BD", "BB", "BH", "BE", "BZ", "BJ", "BM", "BY", "BO", "BA", "BW", "BR", "BN", "BG", "BF",
  "BI", "BT", "CV", "KH", "CM", "CA", "QA", "TD", "CL", "CN", "CY", "CO", "KM", "CG", "KP", "KR",
  "CI", "CR", "HR", "CU", "CW", "DK", "DM", "EC", "EG", "SV", "AE", "ER", "SK", "SI", "ES", "US",
  "EE", "SZ", "ET", "PH", "FI", "FJ", "FR", "GA", "GM", "GE", "GH", "GI", "GD", "GR", "GL", "GP",
  "GU", "GT", "GF", "GG", "GN", "GW", "GQ", "GY", "HT", "HN", "HK", "HU", "IN", "ID", "IQ", "IR",
  "IE", "BV", "NF", "IS", "KY", "CC", "CK", "FO", "GS", "HM", "FK", "MP", "MH", "PN", "SB", "TC",
  "UM", "VG", "VI", "IL", "IT", "JM", "JP", "JE", "JO", "KZ", "KE", "KG", "KI", "KW", "LA", "LS",
  "LV", "LB", "LR", "LY", "LI", "LT", "LU", "MO", "MK", "MG", "MY", "MW", "MV", "ML", "MT", "MA",
  "MQ", "MU", "MR", "YT", "MX", "FM", "MD", "MC", "MN", "ME", "MS", "MZ", "MM", "NA", "NR", "NP",
  "NI", "NE", "NG", "NU", "NO", "NC", "NZ", "OM", "NL", "PK", "PW", "PS", "PA", "PG", "PY", "PE",
  "PF", "PL", "PT", "PR", "GB", "CF", "CZ", "CD", "DO", "RE", "RW", "RO", "RU", "EH", "WS", "AS",
  "BL", "KN", "SM", "MF", "PM", "VC", "SH", "LC", "ST", "SN", "RS", "SC", "SL", "SG", "SX", "SY",
  "SO", "LK", "ZA", "SD", "SS", "SE", "CH", "SR", "SJ", "TH", "TW", "TZ", "TJ", "IO", "TF", "TL",
  "TG", "TK", "TO", "TT", "TN", "TM", "TR", "TV", "UA", "UG", "UY", "UZ", "VU", "VA", "VE", "VN",
  "WF", "YE", "DJ", "ZM", "ZW",
];

function buildCountries() {
  let displayNames;
  try {
    displayNames = new Intl.DisplayNames(["es"], { type: "region" });
  } catch {
    displayNames = null;
  }
  const fallback = {
    ES: "España", MX: "México", AR: "Argentina", CO: "Colombia", CL: "Chile", PE: "Perú",
    VE: "Venezuela", EC: "Ecuador", BO: "Bolivia", PY: "Paraguay", UY: "Uruguay", CR: "Costa Rica",
    PA: "Panamá", GT: "Guatemala", HN: "Honduras", SV: "El Salvador", NI: "Nicaragua", CU: "Cuba",
    DO: "República Dominicana", PR: "Puerto Rico", US: "Estados Unidos", BR: "Brasil", GB: "Reino Unido",
  };
  return ISO_ALPHA2.map((code) => {
    const name = displayNames ? displayNames.of(code) : fallback[code];
    if (!name || name === code) return null;
    return { code, name };
  })
    .filter(Boolean)
    .sort((a, b) => a.name.localeCompare(b.name, "es"));
}

export const COUNTRIES_ES = buildCountries();

export const countryOptionsForSelect = () =>
  COUNTRIES_ES.map((c) => ({ value: c.name, text: c.name }));
